import "./index.css";

import { Header } from "@/components/layout/Header";
import { Hero } from "@/components/hero/Hero";
import { About } from "@/components/about/About";
import { ShowcaseSection } from "@/components/showcase/ShowcaseSection";
import { Contact } from "@/components/contact/Contact";
import { apps } from "@/data/apps";

export function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <ShowcaseSection apps={apps} />
        <Contact />
      </main>
    </>
  );
}

export default App;
